<template>
  <div :class="$style.login" @touchmove.prevent>
    <div :class="$style.mask"></div>
    <div :class="$style.context">
      <div :class="$style.bindAccount">
        <div>
          <div :class="$style.title">中奖记录</div>
          <!--          <div :class="$style.tips">恭喜您，打败99%的用户</div>-->
          <div :class="$style.tips" v-html="voucherContent"></div>
          <div :class="$style.contents">
            <!--            <p style="color: #ff4e4a;font-weight: 700" v-if="type==1">{{ voucherContent }}</p>-->
            <!--            <p :class="$style.giftContent" v-if="type==2">{{ voucherContent }}</p>-->
            <p :class="$style.activation_code" v-if="type==2">礼包码：{{ gift_code }}

              <Button :class="[$style.copy, 'copyBtn']" :data-clipboard-text="gift_code">复制</Button>
            </p>
          </div>
          <div :class="$style.hint" v-if="type==1">提示：该游戏内支付时点击代金券即可查看</div>
          <div :class="$style.gift_hint" v-if="type==2">礼包仅限指定游戏内可领取，详情请见活动规则</div>
        </div>
      </div>
      <i class="iconfont yw-close" @click="close"></i>
    </div>
  </div>
</template>

<script>
import {Field, Button, Toast} from "vant";
import {mapActions} from "vuex";
import CryptoJS from "crypto-js";
import Clipboard from "clipboard";

export default {
  name: "",
  data() {
    return {
      voucherContent: '',
      gift_code: '',
      type: ''
    };
  },
  mounted() {
    this.copy = new Clipboard('.copyBtn');
    this.copy.on('success', () => {
      Toast('复制成功');
    })
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleBlur(e) {
      this.active = e;
    },
    setAccount(phone) {
      this.username = phone;
    },
  },
  components: {},
};
</script>

<style lang="scss" module>
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}
strong{
  font-weight: 700;
}
.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }

  .context {
    position: absolute;
    width: 351px;
    height: 340px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    .bindAccount {
      width: 351px;
      height: 271px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px;
    }

    .title {
      text-align: center;
      font-size: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei-Bold;
      font-weight: 700;
      color: #515151
    }

    .tips {
      text-align: center;
      font-size: 15px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #6f6f6f;
      line-height: 23.61px;
      margin-top: 28px;
      margin-bottom: 15px;

    }

    .giftContent {
      margin-top: 10px;
      font-size: 11.11px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #6f6f6f;
      line-height: 20.83px;
    }

    .activation_code {
      width: 249.65px;
      height: 38.19px;
      background: #f7f7f7;
      border-radius: 19.1px;
      line-height: 39px;
      margin-left: 25px;
      font-size: 13.19px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #6f6f6f;
      margin-top: 15px;

      .copy {
        color: #FFFFFF;
        background: #29B7FE;
        padding: 5px 12px;
        border: none;
        outline: none;
        border-radius: 15px;
        font-size: 13px;
        height: auto;
        line-height: 1;
        margin-left: 15px;
      }
    }

    .contents {
      font-size: 20px;
      font-family: Microsoft YaHei, Microsoft YaHei-Bold;
      font-weight: 700;
      text-align: center;
      color: #6f6f6f;
      line-height: 30.56px;
    }

    .time {
      width: 204.86px;
      height: 20.83px;
      font-size: 12.5px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #ff4f4b;
      line-height: 20.83px;
      background-color: #fee5e5;
      margin-left: 40px;
      margin-top: 9px;
    }

    .hint {
      margin-top: 30px;
      font-size: 9.72px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #6f6f6f;
      line-height: 23.61px
    }

    .gift_hint {
      margin-top: 15px;
      font-size: 9.72px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #6f6f6f;
      line-height: 23.61px
    }
  }

  :global {
    .yw-close {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      font-size: 50px;
      z-index: 1;
      margin: auto;
      font-weight: 100;
    }
  }
}
</style>
